// src/modules/auth/select-workspace/store/useWorkspaceStore.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";
import createSessionStorage from "@core/utils/storage";
import type { TUserWorkspace } from "@modules/auth/select-workspace/types/TUserWorkspace";
// import type { TEditWorkspaceRes } from "../settings/types/TEditWorkspace";

type WorkspaceState = {
  currentWorkspace: TUserWorkspace | null;

  // setters
  setCurrentWorkspace: (workspace: TUserWorkspace | null) => void;
  updateCurrentWorkspace: (patch: Partial<TUserWorkspace>) => void;
  // setFromServer: (w: TEditWorkspaceRes) => void;

  // ui flags (not persisted)
  isSwitching: boolean;
  startSwitch: () => void;
  finishSwitch: () => void;

  // derived (safe to place here; identities are stable)
  isAdmin: () => boolean;
  encodedName: () => string | null;

  clear: () => void;
};

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set, get) => ({
      // state
      currentWorkspace: null,

      // setters
      setCurrentWorkspace: (workspace) => set({ currentWorkspace: workspace }),
      updateCurrentWorkspace: (patch) => {
        const curr = get().currentWorkspace;
        if (!curr) return;
        set({ currentWorkspace: { ...curr, ...patch } });
      },
      // setFromServer: (w) => {
      //   const curr = get().currentWorkspace;
      //   // If your API response doesn’t include `role`, preserve existing role
      //   const role = curr?.role ?? ("user" as TUserWorkspace["role"]);
      //   set({
      //     currentWorkspace: { ...curr, ...w, role } as TUserWorkspace,
      //   });
      // },

      // ui flags
      isSwitching: false,
      startSwitch: () => set({ isSwitching: true }),
      finishSwitch: () => set({ isSwitching: false }),

      // derived helpers
      isAdmin: () => get().currentWorkspace?.role === "admin",
      encodedName: () =>
        get().currentWorkspace
          ? encodeURIComponent(get().currentWorkspace!.name)
          : null,

      // clear
      clear: () =>
        set({
          currentWorkspace: null,
          isSwitching: false,
        }),
    }),
    {
      name: "workspace-storage",
      storage: createSessionStorage(),
      // Only persist the selected workspace, not UI flags:
      partialize: (state) => ({ currentWorkspace: state.currentWorkspace }),
      // (Optional) version/migrate if you change shapes later
      // version: 1,
      // migrate: (persisted, version) => persisted,
    },
  ),
);
